<template>
    <v-container grid-list-lg>
        <v-layout>
            <v-flex md5>
                <h4 class="headline my-2">SMS-kampanjer</h4>
                <v-layout wrap>
                    <v-flex>
                        <TireTypeSelect v-model="filter.tire_types" label="Dekk på dekkhotell nå"
                                        :extra-items="[{value: 'none', text: 'Ingen dekk'}]"/>
                    </v-flex>
                    <v-flex>
                        <CustomerTypeSelect v-model="filter.customer_is_company"/>
                    </v-flex>
                    <v-flex>
                        <LeasingSelect v-model="filter.is_leasing"/>
                    </v-flex>
                    <v-flex>
                        <v-text-field label="Mønsterdybde mindre enn (mm)" type="number" :step="0.1" :min="0"
                                      v-model="filter.tread_depth"/>
                    </v-flex>
                    <v-flex>
                        <v-select class="mt-1" :items="tireStateItems" v-model="filter.tire_state" label="Nytt dekk?" hide-details/>
                    </v-flex>
                    <v-flex>
                        <v-select :items="recipientTypeItems" v-model="filter.recipient_type" label="Send SMS til"
                                  hide-details/>
                    </v-flex>
                    <v-flex shrink align-self-center class="mb-2">
                        <v-btn color="primary" @click="loadRecipients">Hent kundeutvalg</v-btn>
                    </v-flex>
                </v-layout>

                <v-alert type="info" :value="!!recipients.length">
                    Fant {{ recipients.length }} telefonnummer for dette filteret.
                </v-alert>

                <h4 class="headline my-2">Melding</h4>
                <v-card class="mb-3">
                    <v-card-actions class="pl-4 flex justify-space-between">
                        <div v-if="!previewMessage">
                            <small class="pr-3">Sett inn:</small>
                            <v-btn @click="insertTemplate('{{name}}')" small text>
                                Kundenavn
                            </v-btn>
                            <v-btn @click="insertTemplate('{{reg}}')" small text
                                   title="Registreringsnummeret til bilen.">
                                Reg.nr.
                            </v-btn>
                            <v-btn @click="insertTemplate('{{link}}')" small text
                                   title="Lenke som kunden kan trykke på for å melde seg av SMS-lista.">
                                Avreg.lenke
                            </v-btn>
                        </div>
                        <div v-else>Verdier mellom {<!---->{ og }<!---->} erstattes, og meldingen vises slik:</div>
                        <v-checkbox label="Forhåndsvis" v-model="previewMessage" hide-details
                                    class="pa-2 ma-0"></v-checkbox>
                    </v-card-actions>
                    <v-divider/>
                    <v-card-text>
                        <div class="sms-preview-wrapper" v-if="previewMessage">
                            <div class="sms-preview-sender">{{ $root.settings.name }}</div>
                            <div class="sms-preview" v-html="smsPreview"></div>
                        </div>
                        <v-textarea outlined label="Melding" v-model="smsText" hide-details rows="8"
                                    ref="textarea" v-else></v-textarea>
                    </v-card-text>
                </v-card>
                <v-btn color="green" dark @click="send" :disabled="!numSelected">
                    Send melding til {{ numSelected }} mottakere
                    <v-icon right small>send</v-icon>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-layout align-center class="ml-4">
                    <v-checkbox v-model="checkAll" label="Velg alle" :disabled="!recipients.length"/>
                </v-layout>
                <v-data-table :headers="headers" :items="recipients" hide-default-footer class="elevation-1"
                              :items-per-page="10000" :loading="loading">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>
                                <v-checkbox v-model="item.send"></v-checkbox>
                            </td>
                            <td>{{ item.name }}</td>
                            <td>
                                <a :href="`tel:${ item.phone }`">{{ formatPhoneNumber(item.phone) }}</a>
                            </td>
                            <td class="text-center">
                                <v-lazy>
                                    <CustomerCardPopup label="Vis kunde" :customer-id="item.customer_id"
                                                       :key="item.customer_id"/>
                                </v-lazy>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import TireTypeSelect from "@/components/helpers/filter/TireTypeSelect";
import CustomerTypeSelect from "@/components/helpers/filter/CustomerTypeSelect";
import LeasingSelect from "@/components/helpers/filter/LeasingSelect";
import CustomerCardPopup from "@/components/helpers/CustomerCardPopup";
import {formatPhoneNumber, tireStateItems} from "@/helpers";

let exampleValues = {
    'name': 'Ola Nordmann',
    'reg': 'AB12345',
    'link': '<a>' + window.location.origin + '/av/dQ98z</a>'
}

let newEmptyFilter = () => {
    return {
        tire_types: [],
        customer_is_company: null,
        is_leasing: null,
        tread_depth: null,
        recipient_type: null
    }
}

export default {
    components: {
        TireTypeSelect,
        CustomerTypeSelect,
        LeasingSelect,
        CustomerCardPopup
    },
    data() {
        return {
            loading: false,
            filter: newEmptyFilter(),
            recipients: [],

            previewMessage: false,
            smsText: 'Hei {{name}},\n\nMELDING\n\nAvreg? {{link}}\n\n' + this.$root.settings.sms_footer
        }
    },

    methods: {
        formatPhoneNumber,
        loadRecipients() {
            this.loading = true;
            console.log(this.filter)
            this.$http.get(`sms/recipients`, {params: this.filter}).then(response => {
                let recipients = response.data.data;
                recipients.forEach(it => it.send = true);
                this.recipients = recipients;
            }).finally(() => {
                this.loading = false;
            });
        },
        insertTemplate(tmpl) {
            let el = this.$refs['textarea'].$refs['input'];
            const [start, end] = [el.selectionStart, el.selectionEnd];
            el.setRangeText(tmpl, start, end, 'select');
            setTimeout(() => {
                this.smsText = el.value;
            });
        },
        send() {
            let data = {
                'text': this.smsText,
                'recipients': this.selectedRecipients
            };
            this.$http.post(`sms/campaigns`, data).then(response => {
                this.$root.addMessage('SMS-kampanje opprettet. Meldinger vil straks bli sendt ut.', 'green');
                this.filter = newEmptyFilter();
                this.recipients = [];
            }).finally(() => {
                this.loading = false;
            });
        }
    },

    computed: {
        recipientTypeItems() {
            return [
                {value: null, text: 'Både hovednummer og kontaktperson'},
                {value: 'customer', text: 'Kunden (hovednummer)'},
                {value: 'car', text: 'Kontaktperson på bil'}
            ]
        },
        tireStateItems() {
            return tireStateItems
        },
        headers() {
            return [
                {text: 'Send', value: 'name', sortable: false, width: '1px'},
                {text: 'Navn', value: 'name'},
                {text: 'Telefon', value: 'phone'},
                {text: 'Kunde', value: 'customer_id', align: 'center', sortable: false, width: '1px'},
            ];
        },
        selectedRecipients() {
            return this.recipients.filter(it => !!it.send);
        },
        numSelected() {
            return this.selectedRecipients.length;
        },
        checkAll: {
            set(value) {
                this.recipients.forEach(it => it.send = value);
            },
            get() {
                return this.recipients.length === this.numSelected;
            }
        },
        smsPreview() {
            let text = this.smsText.replace(/(<([^>]+)>)/ig, '');
            Object.keys(exampleValues).forEach(key => {
                text = text.replace(`{{${key}}}`, exampleValues[key]);
            })
            return text;
        }
    }
}
</script>

<style lang="scss">
.sms-preview-wrapper {
    max-width: 360px;
    min-height: 480px;
    margin: 0 auto;
    box-shadow: 0 4px 25px rgba(#000, 0.2);
    padding-bottom: 1rem;
}

.sms-preview-sender {
    color: #000;
    font-weight: bold;
    font-size: 140%;
    text-align: center;
    padding: 1rem;
    background-color: #f6f6f6;
    border-bottom: 1px solid #ddd;
    margin-bottom: 1rem;
}

.sms-preview {
    background-color: #e5e4e9;
    padding: 0.7rem 1rem;
    border-radius: 1rem;
    color: #000;
    font-weight: normal;
    white-space: pre-line;
    line-height: 140%;
    margin: 0 1rem;

    &:after {
        content: ' ';
        display: block;
        border-bottom: 25px solid transparent;
        border-left: 25px solid #e5e4e9;
        position: absolute;
        margin-left: -1rem;
        margin-top: -4px;
        transform: rotate(20deg);
    }
}
</style>
